import * as tslib_1 from "tslib";
import * as React from 'react';
import NoteAction from './TaskNoteAction';
import { inject } from 'mobx-react';
import { COPIED_TO_CLIPBOARD } from 'src/constants/messages';
import { copyTextToClipBoard as copyToClipboard } from 'src/utils/dom';
var TaskNoteActions = /** @class */ (function (_super) {
    tslib_1.__extends(TaskNoteActions, _super);
    function TaskNoteActions(props) {
        var _this = _super.call(this, props) || this;
        _this.handleDelete = function (note) {
            _this.props.task.deleteNote(note);
        };
        _this.handleCopy = function (note) {
            copyToClipboard(note.text.trim());
            _this.props.userStore.notify(COPIED_TO_CLIPBOARD);
        };
        return _this;
    }
    TaskNoteActions.prototype.render = function () {
        var note = this.props.note;
        if (note.isReadonly) {
            return React.createElement("div", { className: "right text-muted" },
                React.createElement("small", null, note.createdString));
        }
        return (React.createElement("div", { className: "right" },
            React.createElement("div", { className: "text-muted" },
                React.createElement("small", null, note.createdString)),
            React.createElement(NoteAction, { note: note, icon: "delete", tooltip: "T\u00F6rl\u00E9s", onClick: this.handleDelete }),
            React.createElement(NoteAction, { note: note, icon: "link", tooltip: "M\u00E1sol\u00E1s", onClick: this.handleCopy })));
    };
    TaskNoteActions = tslib_1.__decorate([
        inject('userStore')
    ], TaskNoteActions);
    return TaskNoteActions;
}(React.Component));
export default TaskNoteActions;



//////////////////
// WEBPACK FOOTER
// ./src/pages/tasks/TaskNoteActions.tsx
// module id = 748
// module chunks = 0